import { apiService } from './axios.client';

export const AutomateEndPoints = {
    getJobList: function (input, callback) {
        apiService.get('/job/getJobsList', input)
            .then(callback)
            .catch(callback);
    },
    getXlsx: function (input, callback) {
        apiService.get('/automate/getXlsx', input)
            .then(callback)
            .catch(callback);
    },
    uploadLrs: function (input, callback) {
        apiService.post('/automate/uploadLrs', input)
            .then(callback)
            .catch(callback);
    },
    getLRSFromResult: function (input, callback) {
        apiService.get('/automate/getLRSFromResult', input)
            .then(callback)
            .catch(callback);
    },
    getTemplate: function (input, callback) {
        apiService.get('/automate/getXlsxTemplate', { headers: { 'roadReq': input.roadReq,  'standard': input.standard } })
            .then(callback)
            .catch(callback);
    },
    deleteJob: function (input, callback) {
        apiService.delete('/automate/deleteJob', input)
            .then(callback)
            .catch(callback);
    },
    searchJobs: function(input, callback){
        console.log(input);
        apiService.get('/job/searchJobs', input)
        .then(callback)
        .catch(callback);
    },
    getCals: function(input, callback) {
        //console.log('API Service: Sending input for getCals:', input);
        apiService.post('/automate/getJobsCals', input)
            .then(response => {
                callback(null, response.data);
            })
            .catch(error => {
                //console.error('API Call Failed in Service:', error);
                let errorMessage = 'An unexpected error occurred.';
                if (error.response) {
                    if (typeof error.response.data === 'string' && error.response.data.trim() !== '') {
                        errorMessage = error.response.data;
                    } else {
                        errorMessage = `Server error: Status ${error.response.status}`;
                    }
                } else if (error.request) {
                    errorMessage = 'Network error: Could not reach the server.';
                } else {
                    errorMessage = error.message || 'Error setting up the request.';
                }
                callback(errorMessage, null);
            });
    }
};